import React from 'react';
import './CustomerReview.styles.scss';
import customerReviewImage from '../../../src/assets/images/customer_review.png'
import Rating from '@mui/material/Rating';
import useTranslation from '../../translations/use-translation';

const CustomerReview = () => {
    const translate = useTranslation();
    const reviews = [
        { customer: translate('CUSTOMER_1'), review: translate('REVIEW_1'), date: translate('DATE_1'), rating: 5 },
        { customer: translate('CUSTOMER_2'), review: translate('REVIEW_2'), date: translate('DATE_2'), rating: 4.5 },
        { customer: translate('CUSTOMER_3'), review: translate('REVIEW_3'), date: translate('DATE_3'), rating: 3.5 },
    ];

    return (
        <div className="oa-cs-container">
            <h2 className='heading'>{translate('HEADING')}</h2>
            <p className="heading-sub">What our users are saying about us</p>
            <div className="reviewSection">
                {reviews.map((item) => (
                    <div className="reviewItem" key={item.customer}>
                        <span className="quote-mark">&ldquo;</span>
                        <div className="top">
                            <div className="clientImage">
                                <img src={customerReviewImage} alt="Customer" />
                                <span>{item.customer}</span>
                            </div>
                            <Rating name={`rating-${item.customer}`} defaultValue={item.rating} precision={0.5} readOnly size="small" />
                        </div>
                        <article>
                            <p className="review">{item.review}</p>
                            <p>{item.date}</p>
                        </article>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default CustomerReview;
